import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import CreateEpisode from "./pages/CreateEpisode";
import Watch from "./pages/Watch";
import Share from "./pages/Share";

const TOAST_OPTIONS = {
  style: {
    background: "#121212",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "#F5F5F3",
    fontFamily: "IBM Plex Mono, monospace",
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },
};

function AppRouter() {
  const location = useLocation();
  // Detect session_id during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/create" element={<CreateEpisode />} />
      <Route path="/watch/:id" element={<Watch />} />
      <Route path="/share/:slug" element={<Share />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-center" theme="dark" toastOptions={TOAST_OPTIONS} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
